import { Crown } from "lucide-react";

export default function ProBadge({ className = "", label = "Pro" }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-brand-gold/15 text-brand-gold border border-brand-gold/30 px-2 py-0.5 text-[10px] font-semibold tracking-wide uppercase ${className}`}
      data-testid="pro-badge"
    >
      <Crown className="w-3 h-3" strokeWidth={2.5} /> {label}
    </span>
  );
}
